import React from "react";
import EntidadesBancarias from "Components/EntidadesBancarias";

const EntidadesBancariasPage = () => {
  return <EntidadesBancarias />;
};

export default EntidadesBancariasPage;
